module.exports = __webpack_public_path__ + "static/media/resmed-logo.1f876055.svg";